// @givmo/app-charity — §321 Donations-module route constants (CPA-WEB5, re-homed by CPA-WEB40).
//
// The grants & donations statement is the landing of the Donations module, the charity console's
// primary screen (§2 ruling 2):
//   /donations                   — the §321 statement: the unified table (CPA-BE16 retired the previous
//                                  three-card page and the knob that chose between them).
//   /donations/grants/$grantId   — a single grant's drill-down, kept as a deep link: it redirects into
//                                  the table as `?tab=grant&grant=<id>`.
// `/grants` and `/grants/$grantId` stay addressable as replace-redirects — links to them are in the
// wild, and the BLOCKING e2e attribution spec opens `/grants` until CPA-E2E13 retargets it.
//
// ⚠ THE FILES UNDER `features/grants/` DID NOT MOVE. The app-wide copy rail keys its truth-gated
// allowlist by `features/grants/<file>:<line>`; a file move would change every key. Only the routes
// moved.

import { DONATIONS_GRANT_DETAIL_PATH, DONATIONS_ROUTE } from '../../console/console-routes';

export const GRANTS_ROUTES = {
  statement: DONATIONS_ROUTE,
  detail: (grantId: string) => `${DONATIONS_ROUTE}/grants/${grantId}`,
} as const;

export const GRANTS_DETAIL_PATH = DONATIONS_GRANT_DETAIL_PATH;
